var render, staticRenderFns
import script from "./GridTablesMixin.vue?vue&type=script&lang=ts"
export * from "./GridTablesMixin.vue?vue&type=script&lang=ts"
import style0 from "./GridTablesMixin.vue?vue&type=style&index=0&id=5123bc72&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5123bc72')) {
      api.createRecord('5123bc72', component.options)
    } else {
      api.reload('5123bc72', component.options)
    }
    
  }
}
component.options.__file = "src/mixins/GridTablesMixin.vue"
export default component.exports